import { Escrow } from "../../../services/escrowAPI";

export enum ContextEnum {
  "Support_Ticket" = 1,
  "Message" = 2,
}

export enum ChatStatusEnum {
  "active" = 1,
  "flagged" = 2,
  "blocked" = 3,
}

export interface ChatParticipant {
  id: string;
}

export interface ChatContextType {
  id: number;
}

export interface ChatStatusType {
  id: number;
  name?: string;
}

export interface Chat {
  id:string;
  contextType: ChatContextType;
  status?: ChatStatusType;
  unreadCount: object;
  participants: ChatParticipant[];
  contextId: string;
  lastMessageAt: string;
  lastMessage: string;
  conversations?: Conversation[];
  isFlagged?: boolean;
  isBlocked?: boolean;
  isActive?: boolean;
}

export interface ChatListItem {
  id: string;
  name: string;
  avatar: string | null;
  lastMessage: string;
  timestamp: string;
  unread: number;
  status: "online" | "offline";
  pinned: boolean;
  chat: Chat;
}

export interface ConversationAttachment {
  id: string;
  path: string;
  name?: string;
  type?: string;
}

export interface ConversationSender {
  id: string;
}

export interface ConversationChatId {
  id: string;
}

export interface Conversation {
  id: string;
  isRead: boolean;
  attachments: ConversationAttachment[];
  message: string;
  sender: ConversationSender;
  chatId: ConversationChatId;
  createdAt?: string;
  readBy?: any;
  contextId?: Escrow;
  replyTo?: Conversation;
}

export interface ConversationPagination {
  page: number;
  limit: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  totalCount: number | null;
}

export interface ChatMessage {
  id: string;
  sender: string;
  content: string;
  timestamp: string;
  status: "sent" | "delivered" | "read";
  isMine: boolean;
}

export interface ChatPagination {
  currentPage: number;
  totalCount: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface Country {
  initial: string;
  name: string;
  id: string;
  createdAt: string;
  updatedAt: string;
}

export interface Photo {
  id: string;
  path: string;
}

export interface Role {
  id: string;
  name: string;
}

export interface Status {
  id: string;
  name: string;
}

export interface LocationParticipant {
  stripeConnectedAccountId?: string;
  country: Country;
  province: string;
  isPhoneVerified?: boolean;
  longitude: number;
  latitude: number;
  taxCode: string;
  whatsappNumber: string;
  contactOnWhatsapp: boolean;
  address: string;
  title: string;
  phone: string;
  socialLinks: string[];
  hourlyRate: number;
  bio: string;
  id: string;
  email: string;
  provider: string;
  socialId: string | null;
  firstName: string;
  lastName: string;
  photo: Photo;
  role: Role;
  status: Status;
  createdAt: string;
  updatedAt: string;
}

export interface LocationData {
  [country: string]: {
    [province: string]: LocationParticipant[];
  };
}

export interface ChatStatistics {
  totalChats: number;
  activeChats: number;
  flaggedChats: number;
  blockedChats: number;
  avgResponseTime: string;
  avgResponseTimeMinutes: number;
}

export interface ChatState {
  chats: ChatListItem[];
  selectedChat: ChatListItem | null;
  messages: ChatMessage[];
  conversations: Conversation[];
  conversationPagination: ConversationPagination;
  conversationsLoading: boolean;
  uploadedFiles: ConversationAttachment[];
  loading: boolean;
  error: string | null;
  searchQuery: string;
  adminChats: {
    data: Chat[];
    totalCount: number;
    hasNextPage: boolean;
    currentPage: number;
    totalPages: number;
  } | null;
  adminStatistics: ChatStatistics | null;
  pagination: ChatPagination;
  replyToMessage: { messageId: string; message: string; sender: any; timestamp: string } | null;
  participantsByLocation: LocationData | null;
}
